import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const taskService = {
  listTasks: async (filters = {}) => {
    const response = await api.get(API_ENDPOINTS.TASKS.LIST, {
      params: filters,
    });
    return response.data;
  },
  // Dashboard task cards counted server-side over every task, plus only the
  // overdue / due-soon watchlist rows — see apps/tasks/dashboard.py.
  getDashboardSummary: async (config = {}) => {
    const response = await api.get(API_ENDPOINTS.TASKS.DASHBOARD_SUMMARY, config);
    return response.data;
  },
  getTask: async (taskId) => {
    const response = await api.get(API_ENDPOINTS.TASKS.DETAIL(taskId));
    return response.data;
  },
  createTask: async (data) => {
    const response = await api.post(API_ENDPOINTS.TASKS.LIST, data);
    return response.data;
  },
  bulkCreateTasks: async (data) => {
    const response = await api.post(API_ENDPOINTS.TASKS.BULK_CREATE, data);
    return response.data;
  },
  updateTask: async (taskId, data) => {
    const response = await api.patch(API_ENDPOINTS.TASKS.DETAIL(taskId), data);
    return response.data;
  },
  deleteTask: async (taskId) => {
    const response = await api.delete(API_ENDPOINTS.TASKS.DETAIL(taskId));
    return response.data;
  },
  listTaskComments: async (taskId) => {
    const response = await api.get(API_ENDPOINTS.TASKS.COMMENTS(taskId));
    return response.data;
  },
  addTaskComment: async (taskId, body) => {
    const response = await api.post(API_ENDPOINTS.TASKS.COMMENTS(taskId), { body });
    return response.data;
  },
  deleteTaskComment: async (taskId, commentId) => {
    const response = await api.delete(API_ENDPOINTS.TASKS.COMMENT_DETAIL(taskId, commentId));
    return response.data;
  },
  getTaskBudget: async (taskId) => {
    const response = await api.get(API_ENDPOINTS.TASKS.BUDGET(taskId));
    return response.data;
  },
  updateTaskBudget: async (taskId, data) => {
    const response = await api.patch(API_ENDPOINTS.TASKS.BUDGET(taskId), data);
    return response.data;
  },
  listPropertyTasks: async (propertyId, filters = {}) => {
    const response = await api.get(API_ENDPOINTS.TASKS.BY_PROPERTY(propertyId), {
      params: filters,
    });
    return response.data;
  },
};

export default taskService;